// ==========================================================================
// Ecomwise Facility - Main JS entry
// ==========================================================================

// Import the SCSS so Vite emits a matching CSS bundle alongside the JS.
import '../scss/main.scss';

// Import Bootstrap JS bundle (includes Popper)
import 'bootstrap';

// Theme modules
import { initSlideoutMenu } from './modules/slideout-menu.js';
import { initLogoCarouselMobile } from './modules/logo-carousel-mobile.js';
import { initStickyNavScrollspy } from './modules/sticky-nav-scrollspy.js';
import { initFaqAccordion } from './modules/faq-accordion.js';
document.addEventListener('DOMContentLoaded', () => {
  initSlideoutMenu();
  initLogoCarouselMobile();
  initStickyNavScrollspy();
  initFaqAccordion();

  // Raise hero glow above header only when at the very top of the page AND no
  // nav dropdown is open. The hero sits below the header normally, but at the
  // top we lift it to z-index 1001 so its glow bleeds over the header. That
  // same lift would otherwise cover an open menu dropdown (which is trapped in
  // the header's z-index:1000 stacking context), so we drop the lift whenever a
  // dropdown is open (hover/focus), then restore it when the menu closes.
  const heroMedia = document.querySelector('.ecw-hero__media');
  if (heroMedia) {
    // Count how many submenu items are currently hovered/focused rather than a
    // single boolean, so moving between adjacent items (leave old + enter new)
    // can never leave the flag stuck in the wrong state.
    let openCount = 0;

    const applyZIndex = () => {
      heroMedia.style.zIndex =
        window.scrollY === 0 && openCount === 0 ? '1001' : '';
    };

    applyZIndex();
    window.addEventListener('scroll', applyZIndex, { passive: true });

    // Only top-level menu items that actually open a dropdown should suppress
    // the hero lift. Selecting the panels and using their parent <li> avoids
    // relying on the :has() selector, and the direct-child selector keeps the
    // nested (level 3) lists inside a mega panel out of the count.
    const submenuParents = Array.from(
      document.querySelectorAll('.ecw-menu > li > .sub-menu')
    )
      .map((submenu) => submenu.closest('li'))
      .filter((item, index, all) => item && all.indexOf(item) === index);

    submenuParents.forEach((item) => {
      const open = () => {
        openCount += 1;
        applyZIndex();
      };
      const close = () => {
        openCount = Math.max(0, openCount - 1);
        applyZIndex();
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      // Keyboard users: :focus-within also reveals the submenu.
      item.addEventListener('focusin', (event) => {
        // Ignore focus moving between elements already inside this item.
        if (!item.contains(event.relatedTarget)) {
          open();
        }
      });
      item.addEventListener('focusout', (event) => {
        // Only count as closed when focus leaves the item entirely.
        if (!item.contains(event.relatedTarget)) {
          close();
        }
      });
    });
  }
});
